module.exports = __webpack_public_path__ + "img/porez.c9f3413e.png";